/**
 * LiveFlight Store Aggregator
 * Combines all domain modules into a single Vuex-compatible configuration object
 */

import * as search from "./search";
import * as results from "./results";
import * as filters from "./filters";
import * as selection from "./selection";
import * as checkout from "./checkout";
import * as ui from "./ui";

/**
 * Aggregate all state from modules
 */
export const aggregatedState = {
  ...search.state,
  ...results.state,
  ...filters.state,
  ...selection.state,
  ...checkout.state,
  ...ui.state,
};

/**
 * Aggregate all custom mutations from modules
 * These override the auto-generated mutations from vuex_store_config
 */
export const aggregatedMutations = {
  ...search.mutations,
  ...results.mutations,
  ...filters.mutations,
  ...selection.mutations,
  ...checkout.mutations,
  ...ui.mutations,

  // Cross-module mutation: reset_search clears results + selection
  reset_search(state) {
    // From results module
    state.results = [];
    // From selection module
    state.flight_offer = {};
    state.bags = {};
    state.flexible_bags = {};
    state.held_booking = { id: "", expires_at: "" };
    state.checkout_timer_start = 0;
    state.checkout_timer_amount = 0;
  },

  // Cross-module mutation: prepares all state for a new flight search in a single commit.
  // Replaces 6 separate commits (loading, results, suggestions, search_request, filter_carriers, trigger_search).
  initiate_search(state, search_request) {
    state.loading = true;
    state.results = {};
    state.suggestions = {};
    state.search_request = { ...search_request };
    state.filter_carriers = [];
    state.trigger_search = true;
  },
};

/**
 * Aggregate all local storage keys from modules
 * @returns {string[]} Array of keys to persist
 */
export const getLocalStorageKeys = () => [
  ...search.localStorageKeys,
  ...results.localStorageKeys,
  ...filters.localStorageKeys,
  ...selection.localStorageKeys,
  ...checkout.localStorageKeys,
  ...ui.localStorageKeys,
];

/**
 * Export individual modules for direct access if needed
 */
export const modules = {
  search,
  results,
  filters,
  selection,
  checkout,
  ui,
};
